<template>
  <ul
    class="h-[66px] flex items-center pc:mx-[100px] min-w-0 text-[16px] px-8 2xl:px-8 xl:px-6 lg:px-4"
  >
    <li
      @click="goHome({})"
      class="flex-shrink-0 pr-4 cursor-pointer whitespace-nowrap"
    >
      <img
        class="h-[30px]"
        src="@/assets/image/logo/osn-zh-horizon.png"
        alt="logo"
      />
      <!--      <NuxtImg format="webp"
                     loading="lazy"
                     height="30"
                     src="/logo/osn-zh-horizon.png"
                     alt="logo"/>-->
    </li>
    <li class="grow"></li>
    <!--    關鍵字搜尋-->
    <li
      class="flex-1 mx-4 min-w-[180px] max-w-[420px] cursor-pointer"
    >
      <div
        class="px-[20px] h-[44px] bg-osn-grey-04 rounded-full text-[14px] text-osn-grey-02 flex items-center"
      >
        <input
          type="text"
          class="outline-none flex-1 min-w-0 bg-transparent"
          v-model="searchKeyword"
          :placeholder="$t('placeholder.keyword')"
          @input="handleInput"
          @keyup.enter="handleSpaceKeywordSearch()"
          ref="searchInput"
        />
        <img
          class="search-btn flex-shrink-0 ml-2 w-[20px]"
          :src="searchIcon"
          @click="handleSpaceKeywordSearch()"
          alt=""
        />
      </div>
    </li>
    <!-- 文章頁面 hover 下拉選單 -->
    <li
      class="relative group flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer"
    >
      <NuxtLink
        to="/blog"
        class="pc:mr-[16px] underline underline-offset-2 whitespace-nowrap"
      >
        {{ $t("article.space_article") }}
      </NuxtLink>
      <!-- 下拉選單 -->
      <ul
        class="absolute left-0 top-full invisible group-hover:visible bg-white shadow-lg rounded 
        w-[200px] z-[99999] opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out border 
        border-gray-200 pt-2 pb-1 mt-2"
      >
        <li
          v-for="(article, index) in articles"
          :key="index"
          class="py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200"
        >
          <NuxtLink :to="article.link">{{ article.title }}</NuxtLink>
        </li>
      </ul>
      <!-- 隱形的 hover 區域，確保滑鼠移動到下拉選單時不會消失 -->
      <div
        class="absolute left-0 top-full w-[200px] h-4 invisible group-hover:visible"
      ></div>
    </li>
    <li class="flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer">
      <NuxtLink :to="adServiceUrl" target="_blank"
        class="pc:mr-[16px] underline underline-offset-2 whitespace-nowrap"
      >
        {{ $t("footer.owner_function") }}
      </NuxtLink>
    </li>
    <li class="flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer">
      <NuxtLink
        to="/host/plan"
        class="pc:mr-[16px] underline underline-offset-2 whitespace-nowrap"
      >
        {{ $t("footer.owner_plan") }}
      </NuxtLink>
    </li>
    <li
      v-if="!isLogin"
      class="px-[24px] h-[40px] leading-[40px] bg-osn-yellow-00 text-osn-black-00 rounded-full text-[16px] font-semibold
      flex-shrink-0 whitespace-nowrap min-w-0 max-w-[150px] mx-2 cursor-pointer"
      @click="handelLoginBtn"
    >
      {{ $t("menu.login_reservation") }}
    </li>
    <li
      class="mr-[6px] px-[24px] flex items-center h-[40px] leading-[40px] bg-osn-white-00 border border-osn-yellow-00 text-osn-black-00
      rounded-full text-[15px] font-semibold flex-shrink-0 whitespace-nowrap min-w-0 max-w-[150px] mx-2 cursor-pointer"
      @click="toWebsite(backstageUrl)"
    >
      {{ $t("menu.i_am_owner") }}
      <svg-icon
        name="open_in_new"
        size="20"
        class="ml-[6px] flex-shrink-0"
      ></svg-icon>
    </li>
    <!--    登入後-->
    <li
      v-if="isLogin"
      class="flex items-center mr-2 flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer"
      @click="go('/account')"
    >
      <img
        class="w-[20px] h-[20px] mr-[6px] flex-shrink-0"
        src="@/assets/image/icon/menu/account_circle.svg"
        alt=""
      />
      {{ $t("menu.account_manager") }}
    </li>
    <li
      v-if="isLogin"
      class="flex items-center mr-2 flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer"
      @click="go('/favorites')"
    >
      <svg-icon
        name="heart"
        size="20"
        class="mr-[6px] flex-shrink-0"
      ></svg-icon>
      {{ $t("menu.my_favorites") }}
    </li>
    <li
      v-if="isLogin"
      class="flex items-center mr-2 flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer"
      @click="go('/order/pending')"
    >
      <img
        class="w-[20px] h-[20px] mr-[6px] flex-shrink-0"
        src="@/assets/image/icon/menu/list_alt.svg"
        alt=""
      />
      {{ $t("menu.check_order") }}
    </li>
    <li
      v-if="isLogin"
      class="flex items-center mr-5 flex-shrink-0 mx-2 whitespace-nowrap cursor-pointer"
      @click="handleLogout"
    >
      <img
        class="w-[20px] h-[20px] mr-[6px] flex-shrink-0"
        src="@/assets/image/icon/menu/logout.svg"
        alt=""
      />
      {{ $t("menu.logout") }}
    </li>
  </ul>
</template>
<script setup>
import { computed, nextTick, onMounted, ref } from "vue";
import { useGoTo } from "@/composables/useGoTo";
import { useUserStore } from "~/stores/user";
import { useSearchQueryStore } from "~/stores/searchQuery";
import { useSearchWithStore } from "~/composables/useSearchWithStore";
import { useDebounce } from "~/composables/useDebounce";

const userStore = useUserStore();
const { go, toWebsite, goHome, handelLoginBtn } = useGoTo();
const isLogin = computed(() => userStore.getToken);
const hostUrl = import.meta.env.VITE_APP_BASE_HOST_URL;
const adServiceUrl = import.meta.env.VITE_APP_BASE_AD_SERVICE_URL
const backstageUrl = import.meta.env.VITE_APP_BASE_BACKSTAGE_URL + "login";
const searchQueryStore = useSearchQueryStore();
const { handleSearchWithStore } = useSearchWithStore();
const searchKeyword = ref("");
const searchInput = ref(null);
const { debounce } = useDebounce();

// 定義 hover 文章資料
const articles = ref([
  {
    title: "抓周儀式全攻略",
    link: "https://www.onestep.place/blog/one-year-old-party",
  },
  {
    title: "攝影棚租借重點",
    link: "https://www.onestep.place/blog/photo-studio",
  },
  {
    title: "共享辦公室介紹",
    link: "https://www.onestep.place/blog/shared-office",
  },
  {
    title: "空間租借指南",
    link: "https://www.onestep.place/blog/space-rental",
  },
]);

const props = defineProps({
  handleLogout: {
    type: Function,
  },
});

import arrowLeft from "@/assets/image/icon/space/arrow_left.svg";
import manageSearch from "@/assets/image/icon/menu/manage_search.svg";

const searchIcon = computed(() => {
  return searchKeyword.value ? arrowLeft : manageSearch;
});

onMounted(() => {
  try {
    const keywordStore = searchQueryStore.getSearchKeyword;
    searchKeyword.value = keywordStore || "";
  } catch (error) {
    console.error("Error setting SearchBar.vue initial values:", error);
  }
});

function handleSpaceKeywordSearch() {
  if (!searchKeyword.value) {
    return;
  }
  searchQueryStore.initQueryDate();
  searchQueryStore.setKeyword(searchKeyword.value);
  handleSearchWithStore();
  go("/search-result");
  // searchQueryStore.clearKeyword()
}

const debouncedSearch = debounce(() => {
  /*searchQueryStore.initQueryDate()
  searchQueryStore.setKeyword(searchKeyword.value)
  handleSearchWithStore()*/
  handleSpaceKeywordSearch();
}, 500);

function handleInput() {
  // PC 輸入不自動搜尋
  // debouncedSearch();
}
</script>
<style scoped lang="scss">
li {
  @apply text-[16px] cursor-pointer;
}
</style>
